<ng-container *ngIf="taxInfoItem">
  <!-- Desktop View -->
  <tr
    class="dynamic-table__tr"
    [class.dynamic-table__tr--has-borders]="!isExpanded"
    *ngIf="(isCardView$ | async) === false"
  >
    <td class="dynamic-table__td dynamic-table__td--padding-md">
      <ng-container [ngTemplateOutlet]="checkBoxTemplate"> </ng-container>
    </td>
    <td class="dynamic-table__td dynamic-table__td--padding-md">
      <a
        *ngIf="!taxInfoItem.isSoftLaunchShareClass; else simpleFundName"
        [href]="taxInfoItem?.link"
        >{{ taxInfoItem.fundName }}</a
      >
    </td>
    <td
      class="dynamic-table__td dynamic-table__td--padding-md dynamic-table__td--is-percent"
    >
      {{ taxInfoItem.directUSGovernmentObligations }}
    </td>
    <td
      class="dynamic-table__td dynamic-table__td--padding-md dynamic-table__td--is-percent"
    >
      {{ taxInfoItem.dividendsReceivedDeduction }}
    </td>
    <td
      class="dynamic-table__td dynamic-table__td--padding-md dynamic-table__td--is-percent"
    >
      {{ taxInfoItem.foreignSourceIncome }}
    </td>
    <td
      class="dynamic-table__td dynamic-table__td--padding-md tax-info-row__table-expand-td"
    >
      <ng-container [ngTemplateOutlet]="toggleButtonTemplate"> </ng-container>
    </td>
  </tr>
  <tr
    *ngIf="isExpanded && (isCardView$ | async) === false"
    class="dynamic-table__tr dynamic-table__tr--has-borders"
  >
    <td class="dynamic-table__td dynamic-table__td--padding-md">&nbsp;</td>
    <td class="dynamic-table__td dynamic-table__td--padding-md" colspan="5">
      <eds-panel [hasPadding]="true" theme="grey">
        <ng-container [ngTemplateOutlet]="addtionalInfoTemplate">
        </ng-container>
      </eds-panel>
    </td>
  </tr>
  <!-- Mobile View -->
  <eds-panel
    *ngIf="(isCardView$ | async) === true"
    edsSpacing="lg"
    [hasBorders]="true"
    [hasBorderRadius]="false"
    [hasPadding]="true"
  >
    <div edsSpacing="md" class="cards-mobile__title">
      <ng-container [ngTemplateOutlet]="checkBoxTemplate"> </ng-container>

      <a
        class="text-primary cards-mobile__title--link"
        [href]="taxInfoItem?.link"
        *ngIf="!taxInfoItem.isSoftLaunchShareClass; else simpleFundName"
      >
        <eds-title [level]="3" size="h6" [isLight]="true">
          {{ taxInfoItem.fundName }}
        </eds-title>
      </a>
    </div>
    <div edsSpacing="md">
      <ng-container *ngFor="let primaryData of mobilePrimaryData">
        <eds-info-item [info]="primaryData" edsSpacing="sm"></eds-info-item>
      </ng-container>
    </div>
    <button
      edsButton="icon-only"
      edsSpacing="md"
      *ngIf="isExpanded"
      (click)="toggleExpand()"
    >
      <span class="ft__btn__txt">{{
        "products.us-tax-info-page-accordion-collapse" | translate
      }}</span>
      <eds-icon type="carrot-up" size="small"></eds-icon>
    </button>
    <button edsButton="icon-only" *ngIf="!isExpanded" (click)="toggleExpand()">
      <span class="ft__btn__txt">{{
        "products.us-tax-info-page-accordion-expand" | translate
      }}</span>
      <eds-icon type="carrot-down" size="small"></eds-icon>
    </button>
    <eds-panel
      theme="grey"
      *ngIf="isExpanded"
      class="tax-info-row__additional-panel"
      [class.tax-info-row__additional-panel--is-card-view]="
        (isCardView$ | async) === true
      "
    >
      <ng-container [ngTemplateOutlet]="addtionalInfoTemplate"> </ng-container>
    </eds-panel>
  </eds-panel>

  <ng-template #checkBoxTemplate>
    <eds-checkbox
      class="checkbox-cell-renderer dynamic-table__td--has-checkbox"
      [hideLabel]="true"
      [inline]="true"
      [labelName]="taxInfoItem?.fundName"
      [checked]="taxInfoItem?.isChecked"
      (checkedChange)="onToggle($event)"
    ></eds-checkbox>
  </ng-template>

  <ng-template #toggleButtonTemplate>
    <button
      edsButton="icon-only"
      *ngIf="isExpanded"
      (click)="toggleExpand()"
      class="tax-info-row__table-expand-btn"
    >
      <span class="ft__btn__txt">{{
        "products.us-tax-info-page-accordion-collapse" | translate
      }}</span>
      <eds-icon type="carrot-up" size="small"></eds-icon>
    </button>
    <button
      edsButton="icon-only"
      *ngIf="!isExpanded"
      (click)="toggleExpand()"
      class="tax-info-row__table-expand-btn"
    >
      <span class="ft__btn__txt">{{
        "products.us-tax-info-page-accordion-expand" | translate
      }}</span>
      <eds-icon type="carrot-down" size="small"></eds-icon>
    </button>
  </ng-template>

  <ng-template #addtionalInfoTemplate>
    <div
      class="tax-info-row__wrapper"
      [class.tax-info-row__wrapper--is-card-view]="
        (isCardView$ | async) === true
      "
    >
      <table
        class="tax-info-row__table"
        role="table"
        [edsSpacing]="taxInfoItem.stateFlag ? 'md' : 'sm'"
      >
        <caption class="tax-info-row__table-caption">
          {{
            "products.us-tax-info-page-additional-section" | translate
          }}
        </caption>
        <tbody class="tax-info-row__table-tbody">
          <tr
            class="tax-info-row__table-tr"
            *ngFor="let addtionalInfo of additionalData"
          >
            <th class="tax-info-row__table-th">
              {{ addtionalInfo?.label }}
            </th>
            <td class="tax-info-row__table-td">
              {{ addtionalInfo?.val }}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        class="tax-info-row__table"
        role="table"
        edsSpacing="sm"
        *ngIf="taxInfoItem.stateFlag"
      >
        <caption class="tax-info-row__table-caption">
          {{
            "products.us-tax-info-page-stateflag" | translate
          }}
        </caption>
        <tbody
          class="tax-info-row__table-tbody"
          *ngIf="
            taxInfoItem?.isTaxExemptAvailable && taxInfoItem?.taxExemptData;
            else taxInfoMessage
          "
        >
          <tr
            class="tax-info-row__table-tr"
            *ngFor="let state of taxInfoItem.taxExemptData"
          >
            <th class="tax-info-row__table-th">{{ state.label }}</th>
            <td class="tax-info-row__table-td">{{ state.val }}</td>
          </tr>
        </tbody>
      </table>

      <div edsFlexbox flexWrap="wrap" justifyContent="flex-end">
        <eds-link-item
          theme="basic"
          [title]="'products.us-tax-info-page-accordion-download' | translate"
          (click)="onDownloadExcel($event)"
        ></eds-link-item>
        <span edsPadding edsPaddingRight="xs" edsPaddingLeft="xs">|</span>
        <eds-link-item
          theme="basic"
          [title]="'products.us-tax-info-page-accordion-print' | translate"
          (click)="onPrintExcel($event)"
        ></eds-link-item>
      </div>
    </div>
  </ng-template>
  <ng-template #taxInfoMessage>
    <div
      class="tax-info-row__table-loader"
      *ngIf="taxInfoItem.stateFlag && !isError"
    >
      <ngx-spinner
        name="taxExemptLoadingSpinner"
        bdColor="rgba(0,0,0,0)"
        size="small"
        color="#000"
        type="line-scale-party"
        [fullScreen]="false"
      >
      </ngx-spinner>
    </div>
    <div *ngIf="isError">
      <span>{{
        "products.us-tax-info-page-additional-tax-no-data" | translate
      }}</span>
    </div>
  </ng-template>

  <ng-template #simpleFundName>
    {{ taxInfoItem.fundName }}
  </ng-template>
</ng-container>
